var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor-content',{staticStyle:{"min-height":"200px"},attrs:{"editor":_vm.editor}})
}
var staticRenderFns = []

export { render, staticRenderFns }